import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SwipeDirection, SwipeInfo } from '../../directives/rm-swiper.directive';
import { HasSubscriptions } from '../../../components/has-subscriptions';
import { StaticPathPipe } from '../../pipes/static-path.pipe';

@Component({
  selector: 'app-rm-carousel',
  templateUrl: './rm-carousel.component.html',
  styleUrls: ['./rm-carousel.component.scss']
})
export class RmCarouselComponent extends HasSubscriptions implements OnInit {
  private _images: string[] = [];
  private _currentSlideIndex: number = 0;
  visibleImages: string[] = [];
  imageCount: number;
  @Input() shouldPrefetch: boolean = false;
  prefetchOffset: number = 3;

  @Input() set images(images: string[]) {
    this.visibleImages = [];
    this._images = Array.from(images);
    this.imageCount = images.length;
    this.updateVisibleImages();
  }

  // this function will remove the first image from the _images[] and push to the visibleImages[]
  updateVisibleImages() {
    let i = 0;
    if (this.shouldPrefetch) {
      const t = Math.min(this._currentSlideIndex + this.prefetchOffset, this._images.length);
      while (i < t) {
        if (!this._images.length) break;
        this.visibleImages.push(this._images.shift());
        i++;
      }
    } else {
      this.visibleImages[this._currentSlideIndex] = this._images[this._currentSlideIndex];
    }
  }

  @Input() set currentSlideIndex(i: number) {
    if (this._currentSlideIndex !== i) {
      this._currentSlideIndex = i;
      this.updateVisibleImages();
    }
  }

  get currentSlideIndex() {
    return this._currentSlideIndex;
  }

  @Input() isSelectedCarousel: boolean = true;
  @Input() isRedesign: boolean = false;
  @Input() isNextCarousel: boolean = false;
  @Input() carouselParentName: 'listing-card' | 'listing-details-desktop' | 'expanded-view' | 'gallery-view' | '' = '';
  @Input() isLuxury: boolean = false;
  @Input() isListingDetails: boolean = false;
  @Input() isCommercial: boolean = false;
  @Input() showHighDprImages: boolean = false;
  @Input() imageQualityPercentage: number = 10;
  @Output() onSwipeCarousel: EventEmitter<any> = new EventEmitter();
  @Output() onImageClick: EventEmitter<any> = new EventEmitter();
  @Output() onChangeCarouselIndex: EventEmitter<number> = new EventEmitter();

  placeHolderImage: string;

  // Minimum movement needed before we take a swipe action as moving the images on the carousel
  private _thresholdForHorizontalSwiping: number = 30;

  constructor(private staticPathPipe: StaticPathPipe) {
    super();
  }

  ngOnInit() {
    if (this.isCommercial) {
      this.placeHolderImage = '/assets/listing-default-image/commercial_placeholder@1x.svg';
    } else if (this.isLuxury) {
      this.placeHolderImage = '/assets/listing-default-image/luxury_placeholder@1x.svg';
    } else {
      this.placeHolderImage = '/assets/listing-default-image/residential_placeholder@1x.svg';
    }
  }

  nextSlide($event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
    $event.stopPropagation();
    this.currentSlideIndex = this.currentSlideIndex === this.imageCount - 1 ? 0 : this.currentSlideIndex + 1;
    this.onChangeCarouselIndex.emit(this.currentSlideIndex);
    this.updateVisibleImages();
  }

  prevSlide($event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
    $event.stopPropagation();
    this.currentSlideIndex = this.currentSlideIndex === 0 ? this.imageCount - 1 : this.currentSlideIndex - 1;
    this.onChangeCarouselIndex.emit(this.currentSlideIndex);
    this.updateVisibleImages();
  }

  swipeCarousel(event: SwipeInfo) {
    if (event.swipeEvent.type === 'touchend') {
      if (Math.abs(event.x.current - event.x.start) < (this._thresholdForHorizontalSwiping)
        || (Math.abs(event.y.current - event.y.start) > this._thresholdForHorizontalSwiping)
      ) return;

      if (event.x.direction === SwipeDirection.LEFT) this.nextSlide(event.swipeEvent);
      else this.prevSlide(event.swipeEvent);
    }
  }

  imgErrorHandler(event) {
    const image = this.staticPathPipe.transform(this.placeHolderImage);
    event.target.setAttribute('url', image);
    event.target.setAttribute('data-src', image);
    event.target.setAttribute('data-srcset', image);
    event.target.setAttribute('srcset', image);
    event.target.setAttribute('src', image);
  }

  trackFn(index, item) {
    return item;
  }
}
